//编辑器支持的验证的类型
export type EditorValidatorType = 'required' | 'min' | 'max' | 'minLength' | 'maxLength' | 'email' | 'requriedTrue' | 'pattern' | string;
// 编辑器校验
export interface EditorValidator {
    type: EditorValidatorType;
    value?: any;
    messager?: string;
}
export interface CellEditor {
    type: string;
    options?: any;
    validators?: EditorValidator[]
}

/** 值变化参数 */
export interface ValueChangeParams {
    [key: string]: any;
    /** 编辑器实例 */
    editor?: any;
    /** 编辑器组件实例 */
    instance?: any;
    /** 当前行数据 */
    rowData?: any;
    /** 当前行ID */
    rowId?: any;
    /** 当前编辑字段值 */
    value: any;
}